export type ArticleCategory = "新闻" | "影评" | "专题" | "预告";

export type ContentBlock =
  | { type: "p"; text: string }
  | { type: "h2"; text: string }
  | { type: "quote"; text: string }
  | { type: "image"; src: string; caption: string };

export interface Article {
  id: string;
  title: string;
  category: ArticleCategory;
  date: string;
  author: string;
  summary: string;
  thumbnail: string;
  views: number;
  tags: string[];
  content: ContentBlock[];
}

export const articles: Article[] = [
  {
    id: "wudu-mian-finale-review",
    title: "《雾都谜案》收官：一场关于沉默的推理，也是一次对年代的凝视",
    category: "影评",
    date: "2025-10-12",
    author: "影评人 · 柏舟",
    summary:
      "十二集落幕，《雾都谜案》没有给观众一个酣畅淋漓的答案，而是把问题留在了雾散之后。它真正想破的，或许不是案子。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=editorial%20cinematic%20still%20of%20a%20foggy%201930s%20harbor%20street%20with%20vintage%20lamps%20and%20a%20detective%20silhouette%20deep%20navy%20mist%20warm%20amber%20light%20atmospheric%20film%20photography&width=640&height=420&seq=news-wudu-review&orientation=landscape",
    views: 48210,
    tags: ["雾都谜案", "剧评", "年代剧"],
    content: [
      { type: "p", text: "《雾都谜案》最聪明的地方，是它始终没有把镜头对准凶手。十二集里，观众跟着探长走过码头、商会、照相馆和墓园，看到的却是一座城市如何默契地选择遗忘。" },
      { type: "p", text: "剧集把推理的节奏控制得极稳。每一集抛出的线索都不算惊人，但当它们被摆在同一张桌子上时，观众会突然意识到：真正被隐瞒的从来不是某一个人的罪行，而是一整套被默许的规则。" },
      { type: "h2", text: "雾不是环境，是叙事本身" },
      { type: "p", text: "摄影指导几乎把雾当成了另一个角色。它会在关键对话时升起，在真相即将浮出时散去一点，又在结尾重新合拢。这样的处理让整部剧始终保持一种“看得见但抓不住”的张力。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20rain%20soaked%20old%20harbor%20at%20night%20with%20lamp%20reflections%20on%20wet%20stone%20deep%20navy%20tones%20and%20warm%20amber%20highlights%20film%20grain&width=1000&height=560&seq=news-wudu-inline&orientation=landscape", caption: "剧中的码头场景，几乎全部在真实的雨夜完成拍摄。" },
      { type: "p", text: "演员方面，陆行舟的处理相当克制。他没有把探长演成一个执拗的英雄，而是一个不断在职业本能与私人情感之间摇摆的普通人。温如瑾饰演的法医则提供了另一种冷静，两人之间的对手戏是全剧最耐看的部分。" },
      { type: "h2", text: "它真正想破的案子" },
      { type: "p", text: "结局没有给出狂欢式的正义。举报人现身，真相被公开，但代价也随之而来。剧集用最后二十分钟告诉观众：说出真相从来不是终点，承担真相才是。" },
      { type: "quote", text: "“雾散了，可这座城还是原来的样子。我们破的不是案子，是我们自己。”" },
      { type: "p", text: "如果你期待一部爽感强烈的推理剧，《雾都谜案》可能会让你有点不适应；但如果你想看一部愿意慢下来、认真谈论时代与人的作品，它值得你花十二个晚上。" },
    ],
  },
  {
    id: "shenhai-dangan-renewed",
    title: "《深海档案》确认续订第二季，主创透露将走向海面之上",
    category: "新闻",
    date: "2025-10-11",
    author: "色虎编辑部",
    summary:
      "平台正式宣布《深海档案》续订第二季，第一季留下的“母船”悬念将在新一季得到回应，制作规模也将进一步扩大。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=cinematic%20underwater%20research%20station%20glowing%20in%20dark%20navy%20deep%20sea%20with%20one%20warm%20orange%20light%20editorial%20still%20atmospheric%20sci%20fi%20photography&width=640&height=420&seq=news-shenhai-renew&orientation=landscape",
    views: 36150,
    tags: ["深海档案", "续订", "美剧"],
    content: [
      { type: "p", text: "在第一季收官两周后，平台正式确认《深海档案》将推出第二季。第一季以十集的篇幅构建了一个几乎完全封闭的深海空间，并用“第九层”与“休眠舱”两个悬念把观众牢牢按在屏幕前。" },
      { type: "p", text: "主创 Adrian Wells 在接受采访时表示，第二季不会重复第一季的密闭结构。“我们已经把观众带到海底最深的地方，接下来要做的是让他们看看，海面之上究竟是谁在发号施令。”" },
      { type: "h2", text: "原班人马回归，制作周期延长" },
      { type: "p", text: "据官方信息，Clara Voss、Miles Grant 与 Yara Nasser 均将回归。第二季共八集，剧本已完成初稿，预计明年春季开机，制作周期比第一季延长约两个月，主要用于水下实拍与新型摄影设备的调试。" },
      { type: "p", text: "对于第一季结尾那个没有露面的“站长”，主创只留下一句话：“他没有死，但他也不再是我们认识的那个人。”" },
      { type: "quote", text: "“深海不是背景，是我们对未知的态度。第二季会让这个态度变得更具体。”" },
      { type: "p", text: "目前第一季全集仍在平台热播，站内评分维持在 8.9 分，是今年讨论度最高的科幻剧集之一。" },
    ],
  },
  {
    id: "xinghai-huisheng-imax",
    title: "《星海回声》重映定档：一场必须在大银幕上完成的回声",
    category: "预告",
    date: "2025-10-10",
    author: "色虎编辑部",
    summary:
      "上映一周年之际，《星海回声》宣布以 IMAX 版本重映，并追加一段从未公开的返航影像。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=cinematic%20space%20scene%20with%20an%20astronaut%20silhouette%20before%20a%20vast%20glowing%20nebula%20deep%20navy%20and%20soft%20orange%20starlight%20editorial%20film%20still%20epic%20scale&width=640&height=420&seq=news-xinghai-imax&orientation=landscape",
    views: 29840,
    tags: ["星海回声", "重映", "IMAX"],
    content: [
      { type: "p", text: "《星海回声》将以 IMAX 版本于下月重映，这也是该片首次以完整画幅比例在内地大银幕放映。" },
      { type: "p", text: "片方透露，本次重映将在片尾追加一段约六分钟的返航影像，内容与正片中宇航员收到的“自身求救信号”直接相关，被主创称为“最后一块拼图”。" },
      { type: "h2", text: "为什么值得再看一次" },
      { type: "p", text: "影片最被称道的并非特效规模，而是它对“复制”与“自我”的处理。很多细节在家庭屏幕上会被忽略，比如舱内多次出现的倒影方向，以及通讯延迟的毫秒差。" },
      { type: "p", text: "重映版本将同步推出幕后特辑，包含美术团队为构建深空舱体所做的一年半准备工作。对于喜欢硬科幻的观众来说，这是一次难得的补课机会。" },
    ],
  },
  {
    id: "autumn-lineup-2025",
    title: "2025 秋季档观察：十部新剧里，现实题材正在悄悄回来",
    category: "专题",
    date: "2025-10-09",
    author: "专题组 · 林澈",
    summary:
      "从都市群像到小城治愈，本季新剧的共性是“把镜头放低”。我们梳理了十部作品，看看现实题材如何重新赢得观众。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=editorial%20still%20of%20a%20small%20city%20street%20at%20dusk%20with%20warm%20shop%20lights%20and%20deep%20navy%20blue%20sky%20ordinary%20life%20cinematic%20photography%20soft%20grain&width=640&height=420&seq=news-autumn-lineup&orientation=landscape",
    views: 41260,
    tags: ["秋季档", "行业观察", "现实题材"],
    content: [
      { type: "p", text: "如果要用一个词概括 2025 年的秋季档，“落地”可能最合适。过去两年被大量讨论的宏大设定开始退潮，取而代之的是一批愿意把镜头放低、把节奏放慢的作品。" },
      { type: "h2", text: "一、从“爽点”回到“生活”" },
      { type: "p", text: "《小城食光》《山那边有座城》这类作品并没有强情节，它们靠的是一顿饭、一次返乡、一段沉默来完成叙事。观众愿意留下，是因为这些细节足够真实。" },
      { type: "p", text: "与此同时，悬疑类型也没有消失，而是更愿意把谜题放进具体的社会关系里。《雾都谜案》《逆光而行》都在尝试让“谁做的”让位于“为什么”。" },
      { type: "h2", text: "二、演员结构在变化" },
      { type: "p", text: "本季多部剧集采用了“戏骨 + 新人”的组合，流量权重明显下降。这种配置让群像戏有了更稳定的表演基础，也让年轻演员获得了真正的对手戏。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=cinematic%20wide%20editorial%20shot%20of%20a%20warm%20local%20restaurant%20interior%20at%20night%20with%20steam%20and%20amber%20hanging%20lamps%20deep%20navy%20shadows%20documentary%20style&width=1000&height=560&seq=news-autumn-inline&orientation=landscape", caption: "现实题材的回归，也带来了更讲究生活质感的场景设计。" },
      { type: "h2", text: "三、观众的耐心正在被重新培养" },
      { type: "p", text: "数据显示，本季前十名的剧集中，有六部首集节奏偏慢，但第二周的完播率反而更高。这说明观众并不排斥慢，只要慢得有内容。" },
      { type: "p", text: "当然，现实题材也面临风险：一旦细节失真，观众的容忍度会比架空题材更低。接下来能否持续，取决于创作者是否真的愿意做功课。" },
    ],
  },
  {
    id: "niguang-erxing-character",
    title: "《逆光而行》角色解析：他追的不是凶手，是当年的自己",
    category: "影评",
    date: "2025-10-08",
    author: "影评人 · 阿岚",
    summary:
      "韩剧《逆光而行》用十二集完成了一次身份的回溯。比起反转，它更在意一个人如何在被剥夺之后重新建立自我。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=cinematic%20still%20of%20a%20man%20walking%20out%20of%20a%20prison%20gate%20into%20harsh%20backlight%20deep%20navy%20shadows%20and%20warm%20orange%20sun%20flare%20gritty%20korean%20drama%20look&width=640&height=420&seq=news-niguang-review&orientation=landscape",
    views: 33470,
    tags: ["逆光而行", "角色分析", "韩剧"],
    content: [
      { type: "p", text: "《逆光而行》开场只用了一个镜头：男人走出大门，逆光把他的轮廓削成一条线。从那一刻起，剧集就告诉观众，这不是一个复仇故事，而是一个关于“如何重新成为人”的故事。" },
      { type: "p", text: "剧中最动人的部分，不是他找到第三个目击者，而是他在便利店学着用新的支付方式、在公交车上不知道该坐哪一排。这些微小的笨拙，比任何台词都更能说明十年的重量。" },
      { type: "h2", text: "反转之外，人物逻辑是否成立" },
      { type: "p", text: "第八集的天台对峙是全剧的分水岭。两个同样失去一切的人，一个选择说出真相，一个选择继续沉默。剧本没有偏袒任何一方，而是把两个人放回他们各自的位置上。" },
      { type: "quote", text: "“我不是要你道歉，我只是想知道，那天你有没有看见我。”" },
      { type: "p", text: "如果说有遗憾，大概是中段两集的调查线略显重复。但整体而言，《逆光而行》证明了类型剧完全可以既好看又不敷衍。" },
    ],
  },
  {
    id: "yunhai-zhishang-ep8",
    title: "《云海之上》第 8 话解析：那道裂缝后面，藏着整部作品的答案",
    category: "影评",
    date: "2025-10-07",
    author: "动画观察 · 苏禾",
    summary:
      "最新一话把镜头第一次推到了云层之外。看似是一个奇观场面，实际上是主角成长线的一次集中回收。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20flying%20wooden%20boat%20above%20a%20sea%20of%20clouds%20with%20deep%20navy%20sky%20and%20warm%20orange%20sunrise%20hand%20painted%20style%20wide%20composition&width=640&height=420&seq=news-yunhai-ep8&orientation=landscape",
    views: 27630,
    tags: ["云海之上", "新番", "分集解析"],
    content: [
      { type: "p", text: "《云海之上》播出到第八话，终于把观众带到了云层之外。这个镜头只持续了十几秒，但信息量极大。" },
      { type: "p", text: "从第一话开始，作品就不断强调“地图会变”。而这一次，地图不再是导航工具，而成了主角内心状态的投射：她越接近故乡，航线就越不稳定。" },
      { type: "h2", text: "那句没有说完的台词" },
      { type: "p", text: "老船长在裂缝前说了一半的话，被风声盖住。分镜刻意没有给字幕，这不是失误，而是让观众和主角一起处在信息不全的状态里。" },
      { type: "p", text: "制作层面，本话的云层使用了手绘与三维结合的方式，远景的质感明显优于前几话。配乐也第一次用上了完整的主题旋律，情绪推得很稳。" },
    ],
  },
  {
    id: "longye-jiangming-box-office",
    title: "《长夜将明》票房破八亿，悬疑片凭什么成为今年最大黑马",
    category: "新闻",
    date: "2025-10-06",
    author: "市场组 · 陈默",
    summary:
      "上映十七天，《长夜将明》累计票房突破八亿，成为今年表现最好的原创悬疑片。它的成功并非偶然。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=cinematic%20still%20of%20a%20rainy%20harbor%20town%20at%20night%20with%20amber%20streetlamps%20and%20deep%20navy%20fog%20moody%20detective%20film%20photography&width=640&height=420&seq=news-longye-box&orientation=landscape",
    views: 31280,
    tags: ["长夜将明", "票房", "市场"],
    content: [
      { type: "p", text: "据票务平台数据，《长夜将明》上映第十七天累计票房突破八亿元，排片占比在第三周逆势回升，成为今年原创悬疑片的最好成绩。" },
      { type: "p", text: "与依赖大场面和大 IP 的作品不同，这部影片的成本主要花在剧本打磨与实景拍摄上。导演程子昂透露，剧本前后修改了十九稿，其中第三幕推翻重写两次。" },
      { type: "h2", text: "口碑如何带动长线" },
      { type: "p", text: "影片首日排片并不占优，但次周开始，社交平台上的“二刷细节”讨论显著增加。观众自发整理的时间线让影片获得了持续曝光，这种由内容驱动的传播比宣发更有效。" },
      { type: "p", text: "业内普遍认为，这部影片的表现会给同类原创项目带来更多信心，但也会提高观众对剧本完成度的要求。" },
    ],
  },
  {
    id: "shaqiu-zhiwai-visual",
    title: "《沙丘之外》美术特辑：他们真的在沙漠里造了一座城",
    category: "专题",
    date: "2025-10-05",
    author: "专题组 · 顾言",
    summary:
      "从选址到搭建，从沙尘控制到光线设计，《沙丘之外》的美术团队用一年时间，在一个不存在的地方建起了一座可以被走进去的城。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=cinematic%20behind%20the%20scenes%20of%20a%20desert%20film%20set%20with%20partially%20built%20ancient%20stone%20structures%20on%20golden%20dunes%20deep%20blue%20sky%20warm%20orange%20dust%20light&width=640&height=420&seq=news-shaqiu-art&orientation=landscape",
    views: 25940,
    tags: ["沙丘之外", "美术", "幕后"],
    content: [
      { type: "p", text: "《沙丘之外》最让人震撼的不是特效，而是那些“真的存在过”的场景。美术团队在沙漠边缘搭建了一座占地近两万平方米的聚居地，所有主场景都可以让演员自由行走。" },
      { type: "h2", text: "风是最大的对手" },
      { type: "p", text: "沙尘会在一夜之间埋掉半米高的道具，团队为此设计了可拆卸的地基系统，每天收工后把易损部分整体吊起。这种近乎偏执的做法，让影片的质感始终统一。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=cinematic%20desert%20set%20with%20carved%20stone%20arches%20half%20buried%20in%20sand%20at%20sunset%20warm%20orange%20glow%20and%20deep%20navy%20sky%20epic%20production%20design%20photography&width=1000&height=560&seq=news-shaqiu-inline&orientation=landscape", caption: "影片中的聚居地主场景，绝大部分由实景搭建完成。" },
      { type: "p", text: "光线设计同样讲究。摄影指导坚持只在清晨与日落前两小时拍摄外景，以保留沙粒反射的暖色调，这也让整个剧组的作息完全围绕着太阳运转。" },
      { type: "p", text: "这些幕后细节或许不会被所有观众注意到，但正是它们构成了大银幕上那种难以言说的真实感。" },
    ],
  },
  {
    id: "xiju-yanjiusuo-new-season",
    title: "《喜剧研究所》官宣新一季，赛制调整为“无淘汰”",
    category: "新闻",
    date: "2025-10-04",
    author: "综艺组 · 白桃",
    summary:
      "新一季将取消淘汰机制，改为积分累计制，让创作者有更多时间打磨作品。节目组称这是一次“把节奏还给内容”的调整。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=comedy%20club%20stage%20with%20warm%20amber%20spotlight%20and%20deep%20navy%20background%20single%20vintage%20microphone%20editorial%20photography%20playful%20retro%20mood&width=640&height=420&seq=news-xiju-season&orientation=landscape",
    views: 19870,
    tags: ["喜剧研究所", "综艺", "赛制"],
    content: [
      { type: "p", text: "《喜剧研究所》今日官宣新一季阵容与赛制。最大的变化是取消淘汰，改为贯穿全季的积分累计，最终由现场观众与创作者互评共同决定名次。" },
      { type: "p", text: "节目组表示，上一季不少优质作品因为准备时间不足而未能呈现最佳状态。取消淘汰后，每组创作者将获得更完整的排练周期。" },
      { type: "h2", text: "新增“开放麦”环节" },
      { type: "p", text: "新一季还将加入开放麦环节，创作者可以把未成形的段子先拿到小剧场试演，观众反馈会直接进入下一期的创作。" },
      { type: "p", text: "节目预计于年底上线，具体阵容将在下周陆续公布。" },
    ],
  },
  {
    id: "qiri-zhijian-review",
    title: "《七日之间》：如果只能回去一次，你会选哪一天",
    category: "影评",
    date: "2025-10-03",
    author: "影评人 · 柏舟",
    summary:
      "这部日本电影用一个温柔的设定，问了一个并不温柔的问题：我们想修补的，究竟是别人的遗憾，还是自己的愧疚。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=cozy%20japanese%20bookshop%20interior%20at%20night%20with%20warm%20lamp%20glow%20and%20deep%20indigo%20window%20light%20floating%20paper%20gentle%20magical%20cinematic%20still&width=640&height=420&seq=news-qiri-review&orientation=landscape",
    views: 24110,
    tags: ["七日之间", "日本电影", "治愈"],
    content: [
      { type: "p", text: "《七日之间》的设定并不新鲜：旧书店店主获得七天时间，可以回到客人最想说抱歉的那一天。但影片没有把它拍成一段段奇观，而是耐心地拍了很多“什么都没发生”的时刻。" },
      { type: "p", text: "最打动人的是第三个故事。一位老人回去不是为了道歉，而是为了再吃一次妻子做的饭。他坐在桌前，什么都没说，镜头停了将近两分钟。" },
      { type: "h2", text: "关于“回去”的克制" },
      { type: "p", text: "影片始终没有解释这套规则的来源，也没有让主角真正改变过去。它更关心的是：当你知道了真相，你打算怎么继续现在的生活。" },
      { type: "quote", text: "“回去不是为了改，是为了好好说一声再见。”" },
      { type: "p", text: "结尾的处理很轻。店主合上账本，店门外的雪停了。这个镜头没有配乐，却比任何煽情段落都更有力量。" },
    ],
  },
  {
    id: "shanhai-huijuan-animation",
    title: "《山海绘卷》幕后：一支笔如何画出会呼吸的山",
    category: "专题",
    date: "2025-10-02",
    author: "动画观察 · 苏禾",
    summary:
      "从水墨笔触到三维空间，制作团队分享了中国风动画在技术上的一次新尝试，也谈到了最难的部分其实是“留白”。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=chinese%20ink%20painting%20animation%20key%20visual%20with%20floating%20mountains%20mist%20and%20a%20small%20figure%20holding%20a%20brush%20deep%20navy%20ink%20wash%20warm%20golden%20mist%20wide%20composition&width=640&height=420&seq=news-shanhai-bts&orientation=landscape",
    views: 22840,
    tags: ["山海绘卷", "国漫", "幕后"],
    content: [
      { type: "p", text: "《山海绘卷》最被讨论的是它的“水墨感”。制作团队透露，片中大量镜头并非单纯二维绘制，而是用三维空间搭出体积，再逐层贴上水墨笔触。" },
      { type: "h2", text: "最难的是留白" },
      { type: "p", text: "导演墨白说，团队花了最多时间讨论的不是如何画满，而是哪里不画。“中国画的呼吸来自空白，动画却总想填满每一帧，这个矛盾我们调了很久。”" },
      { type: "p", text: "为了解决镜头运动时的笔触抖动，团队开发了一套笔触稳定工具，在保留手绘随机感的同时，避免画面闪烁。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=chinese%20ink%20wash%20landscape%20with%20floating%20peaks%20and%20a%20tiny%20boat%20in%20mist%20deep%20navy%20and%20warm%20gold%20tones%20minimal%20elegant%20composition&width=1000&height=560&seq=news-shanhai-inline&orientation=landscape", caption: "片中大量场景以留白构建空间感。" },
      { type: "p", text: "目前该作更新至第六话，站内评分 8.9，是今年国漫中口碑最稳的作品之一。" },
    ],
  },
  {
    id: "winter-movies-preview",
    title: "冬季档前瞻：六部值得提前标记的影片",
    category: "预告",
    date: "2025-10-01",
    author: "色虎编辑部",
    summary:
      "从科幻续作到小成本现实题材，我们整理了冬季档最值得关注的六部影片，以及它们各自的看点。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=cinematic%20collage%20style%20still%20of%20a%20snowy%20city%20street%20at%20night%20with%20warm%20orange%20cinema%20marquee%20lights%20and%20deep%20navy%20sky%20moody%20film%20atmosphere&width=640&height=420&seq=news-winter-preview&orientation=landscape",
    views: 18620,
    tags: ["冬季档", "片单", "前瞻"],
    content: [
      { type: "p", text: "冬季档一向是类型片的集中战场。今年最明显的变化是，中小成本作品的数量明显增加，题材也更贴近现实。" },
      { type: "h2", text: "一、《长夜将明》导演新作" },
      { type: "p", text: "程子昂的新片继续聚焦小城叙事，但这次把视角放在了基层医疗系统。据提前看片的观众反馈，影片的情绪浓度比前作更高。" },
      { type: "h2", text: "二、两部科幻续作" },
      { type: "p", text: "《星海回声》团队的新项目已进入后期，另一部备受期待的太空题材作品则选择在圣诞档上映。两者风格差异明显，前者偏哲思，后者偏冒险。" },
      { type: "p", text: "其余四部作品涵盖家庭、犯罪与动画类型，我们会在影片定档后第一时间更新完整片单。" },
    ],
  },
  {
    id: "xiaocheng-shiguang-food",
    title: "《小城食光》里的那碗面，为什么让人看饿了也看哭了",
    category: "影评",
    date: "2025-09-30",
    author: "影评人 · 阿岚",
    summary:
      "这部没有强情节的治愈剧，靠一碗面讲清了三代人的关系。它的秘诀不是美食镜头，而是“谁在吃”。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=cozy%20small%20noodle%20shop%20at%20night%20with%20steam%20rising%20from%20a%20bowl%20warm%20amber%20lamp%20light%20and%20deep%20blue%20street%20outside%20window%20cinematic%20food%20photography&width=640&height=420&seq=news-shiguang-food&orientation=landscape",
    views: 20460,
    tags: ["小城食光", "治愈", "美食剧"],
    content: [
      { type: "p", text: "《小城食光》几乎没有反派，也没有大起大落。它的冲突都发生在很小的空间里：灶台前、饭桌旁、店门口那张旧木凳上。" },
      { type: "p", text: "第七集里，女孩给一位老顾客多加了一勺浇头。对方愣了一下，说“她以前也是这么给我加的”。这场戏没有一句解释，却把人物关系交代得干干净净。" },
      { type: "h2", text: "食物是关系的容器" },
      { type: "p", text: "剧集很少拍食物的特写，更多时候镜头停在被推到桌边的碗、没吃完的面、以及两双同时伸向筷子的手。" },
      { type: "p", text: "这也是它区别于一般美食剧的地方：它不把食物当奇观，而把它当成人与人之间最日常的表达方式。" },
    ],
  },
  {
    id: "autumn-ratings-weekly",
    title: "一周剧集热度榜：《雾都谜案》反超登顶，《深海档案》稳居前三",
    category: "新闻",
    date: "2025-09-29",
    author: "数据组 · 陈默",
    summary:
      "本周剧集热度榜发生变化，《雾都谜案》凭借收官集讨论量反超登顶，《云海之上》成为唯一进入前五的动画作品。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=editorial%20abstract%20data%20visualization%20on%20a%20deep%20navy%20background%20with%20warm%20orange%20bars%20and%20lines%20minimal%20modern%20infographic%20style&width=640&height=420&seq=news-ratings-week&orientation=landscape",
    views: 15320,
    tags: ["热度榜", "数据", "剧集"],
    content: [
      { type: "p", text: "本周热度榜前三名依次为《雾都谜案》《声线对决 第六季》与《深海档案》。其中《雾都谜案》在收官集播出后讨论量上涨 46%，成功反超。" },
      { type: "p", text: "动画作品《云海之上》位列第五，是本周排名最高的非真人作品，其第八话的单集讨论量创下本季新高。" },
      { type: "h2", text: "口碑与热度的错位" },
      { type: "p", text: "值得注意的是，本周评分最高的《云海之上》（9.0）并未登顶热度榜，而部分评分中等的作品依靠话题营销维持了较高曝光。" },
      { type: "p", text: "完整榜单每周一更新，数据来源于站内播放、收藏与讨论综合计算。" },
    ],
  },
  {
    id: "bianjiexian-review",
    title: "《边界线》：一部拒绝给答案的犯罪剧",
    category: "影评",
    date: "2025-09-28",
    author: "影评人 · 柏舟",
    summary:
      "八集的篇幅里，《边界线》几乎没有一场激烈的动作戏，却让人从头紧张到尾。它的力量来自一种持续的道德不适。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=lonely%20border%20checkpoint%20at%20night%20in%20rain%20with%20deep%20navy%20darkness%20and%20small%20warm%20orange%20headlights%20cinematic%20wide%20empty%20landscape&width=640&height=420&seq=news-bianjie-review&orientation=landscape",
    views: 17890,
    tags: ["边界线", "英剧", "剧评"],
    content: [
      { type: "p", text: "《边界线》的故事发生在一个几乎什么都没有的地方：一条公路、一个检查站、几间低矮的房子。正是这种空旷，让人物之间的每一次对视都显得格外沉重。" },
      { type: "p", text: "剧集没有把主角塑造成孤胆英雄。他会犹豫、会妥协，也会在关键时刻选择对自己更安全的做法。观众很难完全站在他这一边，而这正是作品的意图。" },
      { type: "h2", text: "“边界”是双重隐喻" },
      { type: "p", text: "地理上的边界只是表层，真正被反复讨论的是职业与良知之间的那条线。剧中多次出现角色站在门槛上的镜头，位置本身就是态度。" },
      { type: "p", text: "结局没有给出审判，只留下一个空镜头。有人觉得不够痛快，但这种克制恰恰是它最诚实的地方。" },
    ],
  },
  {
    id: "tiger-weekly-10",
    title: "色虎周报：本周五部新片定档，三部剧集发布首支预告",
    category: "新闻",
    date: "2025-09-27",
    author: "色虎编辑部",
    summary:
      "本周影视行业动态汇总：五部影片定档、三部剧集发布预告、两部动画公布制作阵容，另有多个项目官宣开机。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=modern%20cinema%20lobby%20with%20warm%20amber%20marquee%20bulbs%20and%20deep%20navy%20walls%20editorial%20photography%20of%20movie%20posters%20soft%20focus%20background&width=640&height=420&seq=news-weekly-10&orientation=landscape",
    views: 13480,
    tags: ["周报", "定档", "行业"],
    content: [
      { type: "p", text: "本周共有五部影片宣布定档，其中两部选择同一天上映，冬季档的竞争提前升温。" },
      { type: "p", text: "剧集方面，三部新作发布首支预告，题材分别为年代悬疑、都市情感与科幻。从预告质感来看，年代悬疑项目的完成度最受关注。" },
      { type: "h2", text: "动画项目动态" },
      { type: "p", text: "两部国产动画公布制作阵容，其中一部改编自同名漫画，另一部为原创企划。两部作品均计划于明年上线。" },
      { type: "p", text: "此外，本周还有四个项目官宣开机，具体信息可在站内搜索项目名称查看。" },
    ],
  },
];